import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import type TasProgramTemplateModel from './tas-program-template.ts';
import type TasGroupModel from './tas-group.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class TasGroupingModel extends Model {
  @attr declare memberId: string;

  /*************************
   **  Relationships      **
   *************************/
  @belongsTo('tas-group', { async: false, inverse: 'tasGroup' }) declare tasGroup: TasGroupModel;
  @belongsTo('tas-program-template', { async: false, inverse: 'tasGroupings', polymorphic: true })
  declare tasProgramTemplate: TasProgramTemplateModel;

  [Type] = 'tas-grouping' as const;
}
